import qraphql from './graphql/yats.graphql';

/**
 * @param {Object} params
 * @param {String} params.assetId
 * @param {String} params.provider
 * @param {Array<{begin: Number, end?: Number}>} params.cutRanges
 * @param {{geoRestriction: String?, accessLevel: String?}} [params.protection]
 * @returns {Promise<{assetId: Number, originAssetId: Number, errorMessage: String}>}
 */
export async function createClip({ assetId, provider, cutRanges, protection }) {
    const { createClips } = await this.query(qraphql.CreateClips, {
        assetId,
        provider,
        cutRanges,
        protection,
    });
    return {
        assetId: createClips.assetId,
        originAssetId: createClips.originAssetId,
        errorMessage: createClips.message,
    };
}

/**
 * @param {Object} params
 * @param {String} params.assetId
 * @param {String} params.provider
 * @param {Array<{begin: Number, end?: Number}>} params.cutRanges
 * @returns {Promise<Boolean>}
 */
export async function trimAsset({ assetId, provider, cutRanges }) {
    const { trimAsset: success } = await this.query(qraphql.TrimAsset, {
        assetId,
        provider,
        cutRanges,
    });

    return success;
}
